<app-modal>
  <div modal-header>
    <span  i18n="Modal Titel for Registration@@register.modal.title">Forgot Password</span>
  </div>
  <div modal-body>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group form-label-group">
        <input type="text" id="inputResetCode" class="form-control" formControlName="resetCode" required/>
        <label for="inputResetCode" i18n="Input Label@@resetPassword.form.resetCode.label">Reset Code</label>
        <div *ngIf="form.controls.resetCode.invalid && (form.controls.resetCode.dirty || form.controls.resetCode.touched)" class="invalid-tooltip">
          <div *ngIf="form.controls.resetCode.errors.required" i18n="Error message when no email is provided@@forgotPassword.form.errors.email.required">Email is required.</div>
        </div>
      </div>
      <div class="form-group form-label-group">
        <input type="password" id="inputPassword" class="form-control" formControlName="password" />
        <label for="inputPassword" i18n="Input Label@@resetPassword.form.password.label">Password</label>
        <div *ngIf="form.controls.password.invalid && (form.controls.password.dirty || form.controls.password.touched)" class="invalid-tooltip">
          <div *ngIf="form.controls.password.errors.required" i18n="Error message when no password is provided@@resetPassword.form.errors.password.required">Password is required.</div>
          <div *ngIf="form.controls.password.errors.minLength" i18n="Error message when password hasn't reach min-lenght@@resetPassword.form.errors.password.minLength">Password needs to be at least 4 characters long!</div>
        </div>
      </div>
      <div class="form-group form-label-group">
        <input type="password" id="inputPasswordRepeat" class="form-control" formControlName="passwordRepeat" />
        <label for="inputPasswordRepeat" i18n="Input Label@@resetPassword.form.passwordRepeat.label">Repeat password</label>
        <div *ngIf="form.controls.passwordRepeat.invalid && (form.controls.passwordRepeat.dirty || form.controls.passwordRepeat.touched)" class="invalid-tooltip">
          <div *ngIf="form.controls.passwordRepeat.errors.required" i18n="Error message when no password is provided@@resetPassword.form.errors.passwordRepeat.required">Password is required.</div>
          <div *ngIf="form.controls.passwordRepeat.errors.minLength" i18n="Error message when password hasn't reach min-lenght@@resetPassword.form.errors.passwordRepeat.minLength">Password needs to be at least 4 characters long!</div>
          <div *ngIf="form.controls.passwordRepeat.errors.passwordMismatch" i18n="Error message when confirm password does not match@@resetPassword.form.errors.passwordRepeat.passwordMismatch">Passwords do not match!</div>
        </div>
      </div>
      <div class="text-center">
        <div class="btn-primary-container">
          <button type="submit" class="btn btn-primary">
            <span i18n="Register Form Submit button@@resetPassword.form.submit.label">Reset Password</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</app-modal>